
















































































































































































































































































































import storage from 'baimahu/storage';
import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import moment, { Moment } from 'moment';
import { dateTime, date } from '@/util/adapter';
import { StatusEnum, TypeEnum, STATUS_LIST, WARE_TYPE_LIST } from './constant';
const { VUE_APP_FCAPI: FCAPI, VUE_APP_API } = process.env;
const _ = {
  reduce: require('lodash/reduce'),
  each: require('lodash/each'),
};
const numeral = require('numeral');
const clean = require('bmh/clean-empty-obj');

enum SortEnum { // 适配 antd table sort，不得修改
  default = '',
  asc = 'ascend',
  desc = 'descend',
}

enum EditableWareFieldEnum {
  sort = 'sort',
  stock = 'stock',
  bonus = 'bonus',
}

interface SortFilter {
  sort_by_sort: SortEnum;
  sort_by_price: SortEnum;
  sort_by_stock: SortEnum;
  sort_by_sale_volume: SortEnum;
  sort_by_gross_profit: SortEnum;
  sort_by_bonus: SortEnum;
  sort_by_create_time: SortEnum;
}

interface Filter extends SortFilter {
  category_id: number[];
  status: StatusEnum;
  name: string | undefined;
  type: string[];
  saler: string[];
  create_time_range: Moment[];
  price_range: string[];
  sale_volume_range: string[];
  stock_range: string[];
}

interface Saler {
  id: string;
  level: string;
  name: string;
  mobile: number;
  member_count: string;
}

interface Ware {
  category_id_first: number;
  category_id_second: number;
  id: number;
  sort: number;
  thumbnail: string;
  name: string;
  price: number;
  price_text: string;
  type: string;
  type_text: string;
  type_secondary: string;
  type_secondary_text: string;
  stock: number;
  stock_total: number;
  sale_volume: number;
  gross_profit: number;
  bonus: number;
  saler_count: number;
  create_time: Moment;
  create_time_text: string;
  commission_one_self: string;
  commission_one_two: string;
  commission_two: string;
  sku_attribute_json: any;
  is_enable_attribute: any;
}

interface CheckData {
  checked_list: number[];
  indeterminate: boolean;
  is_all_checked: boolean;
}

interface GlobalCheckData {
  [propName: number]: CheckData;
}

interface TablePopup {
  id: number;
  visible: boolean;
  value: string | number;
  field: EditableWareFieldEnum;
}

interface SalerModal extends Pagination<Saler> {
  visible: boolean;
}

interface WarePreviewModal {
  visible: boolean;
  qrcode: string;
}

interface StockModal {
  id: string;
  visible: boolean;
  title: string;
  merchantName: string;
  merchantNumber: string;
  salerList: string[];
  is_sku: boolean;
  stock_table: string[];
  attr_name: string[];
}

interface BonusModal {
  id: string;
  visible: boolean;
  oneselfNumber: string;
  firstSalerNumber: string;
  secondSalerNumber: string;
  price: string;
}

const FILTER_DEFAULT_TYPE: any = [];

async function fetchPosterQrcode(id: number) {
  const _data = ((await axios.get(`${FCAPI}/shang/ware/preview/${id}`)) || {}).data || {};
  if (_data.status !== 200) {
    console.error(_data.message);
    return '';
  }
  return _data.data;
}

async function fetchWarePageData(): Promise<Ware.WarePageData> {
  const _data = ((await axios.get(`${FCAPI}/shang/ware/preview`)) || {}).data || {};
  if (_data.status !== 200) {
    console.error(_data.message);
    return {
      is_app_bound: false,
      is_app_online: false,
    };
  }
  return _data.data;
}

function getSortFilter(): SortFilter {
  return {
    sort_by_sort: SortEnum.asc,
    sort_by_price: SortEnum.default,
    sort_by_stock: SortEnum.default,
    sort_by_sale_volume: SortEnum.default,
    sort_by_gross_profit: SortEnum.default,
    sort_by_bonus: SortEnum.default,
    sort_by_create_time: SortEnum.default,
  };
}

function getFilter(status: StatusEnum = StatusEnum.online): Filter {
  return {
    category_id: [0],
    status,
    name: undefined,
    type: FILTER_DEFAULT_TYPE,
    saler: [],
    create_time_range: [],
    price_range: ['', ''],
    sale_volume_range: ['', ''],
    stock_range: ['', ''],
    ...getSortFilter(),
  };
}

function getSaler(remote_saler?: any): Saler {
  remote_saler = remote_saler || {};
  return {
    id: remote_saler.id,
    name: remote_saler.name,
    level: remote_saler.level,
    mobile: remote_saler.mobile,
    member_count: remote_saler.level === 1 ? remote_saler.member_count : '-',
  };
}

function getSalerData(remote?: RemotePagination<any>): Pagination<Saler> {
  remote = (remote || {}) as RemotePagination<any>;
  const current = remote.current_page;
  return {
    current: Number(current) || current || 1,
    data: (remote.data || [{}, {}, {}]).map((remote_saler: any) => getSaler(remote_saler)),
    last: remote.last_page || 1,
    size: remote.per_page || 1,
    total: remote.total || 0,
  };
}

function getWare(remote?: any, option?: { saler_total: number }): Ware {
  remote = remote || {};
  option = option || {
    saler_total: 0,
  };
  const numeral_price = numeral(remote.price || 0).divide(100);
  const numeral_bonus = numeral(remote.commission_rule || 0).divide(100);
  const saler_count = numeral(option.saler_total || 0)
    .subtract(remote.clerk_relevance_count)
    .value();
  return {
    category_id_first: remote.category_id_first,
    category_id_second: remote.category_id_second,
    id: remote.id,
    sort: remote.sort,
    thumbnail: (remote.banner_url_list || [])[0] || '',
    name: remote.name || '',
    price: numeral_price.value(),
    price_text: numeral_price.format('0.00'),
    type: remote.type,
    type_text: remote.type === 1 ? '实物' : '虚拟',
    type_secondary: remote.type_secondary,
    type_secondary_text: remote.type_secondary === 1 ? '/兑换码' : '/无',
    stock: remote.current_stock,
    stock_total: remote.stock_total,
    sale_volume: remote.real_sales,
    gross_profit: remote.profit_yuan,
    bonus: numeral_bonus.value(),
    saler_count,
    create_time: moment(remote.create_time),
    create_time_text: dateTime(moment(remote.create_time)),
    commission_one_self: remote.commission_one_self,
    commission_one_two: remote.commission_one_two,
    commission_two: remote.commission_two,
    sku_attribute_json: remote.sku_attribute_json,
    is_enable_attribute: remote.is_enable_attribute,
  };
}

function getTableData(remote?: { ware_list: any; total_clerk_number: number }): Pagination<Ware> {
  const _remote = remote || { ware_list: {}, total_clerk_number: 0 };
  const ware_data: RemotePagination<any> = _remote.ware_list;
  const current = ware_data.current_page;
  return {
    current: Number(current) || current || 1,
    data: (ware_data.data || []).map((remote_ware: any) =>
      getWare(remote_ware, { saler_total: _remote.total_clerk_number })
    ),
    last: ware_data.last_page || 1,
    size: ware_data.per_page || 1,
    total: ware_data.total || 0,
  };
}

function getCheckData(
  checked_list: number[] = [],
  is_all_checked: boolean = false,
  indeterminate: boolean = false
): CheckData {
  return {
    checked_list,
    indeterminate,
    is_all_checked,
  };
}

function getGlobalCheckData(page_count: number = 1): GlobalCheckData {
  const data: GlobalCheckData = {};
  for (let i = 1; i <= page_count; i++) {
    data[i] = getCheckData();
  }
  return data;
}

function getTablePopup(id?: Ware['id'], value?: string | number, field?: EditableWareFieldEnum): TablePopup {
  return {
    id: id || 0,
    visible: !!id,
    value: value || '',
    field: field || EditableWareFieldEnum.sort,
  };
}

function getSalerModal(visible: boolean = false, data: Pagination<Saler> = getSalerData()): SalerModal {
  return {
    visible,
    ...data,
  };
}

function getWarePreviewModal(visible: boolean = false, qrcode: string = ''): WarePreviewModal {
  return {
    visible,
    qrcode,
  };
}

function getStockModal(visible: boolean = false): StockModal {
  return {
    id: '',
    visible,
    title: '',
    merchantName: '',
    merchantNumber: '',
    salerList: [],
    is_sku: false,
    stock_table: [],
    attr_name: [],
  };
}

function getBonusModal(visible: boolean = false): BonusModal {
  return {
    id: '',
    visible,
    oneselfNumber: '',
    firstSalerNumber: '',
    secondSalerNumber: '',
    price: '',
  };
}

function getSummary(): { [prop: number]: number } {
  return {
    [StatusEnum.online]: 0,
    [StatusEnum.out]: 0,
    [StatusEnum.stock]: 0,
  };
}

const API: any = {
  category_list: `${FCAPI}/shang/ware/category`,
  query: `${VUE_APP_API}/qy/ware/list/query`,
  update_sort: `${VUE_APP_API}/qy/ware/list/edit-sort`,
  update_stock: `${VUE_APP_API}/qy/ware/list/edit-current-stock`,
  update_bonus: `${VUE_APP_API}/qy/ware/list/edit-commission`,
  online: `${VUE_APP_API}/qy/ware/list/force-up`,
  stock: `${VUE_APP_API}/qy/ware/list/force-down`,
  fetch_ware_saler_data: `${VUE_APP_API}/qy/user/clerk/ware-clerk`,
  stock_data: `${VUE_APP_API}/qy/user/clerk/ware-stock`,
  edit_stock: `${VUE_APP_API}/qy/ware/edit-stock`,
  edit_commission: `${VUE_APP_API}/qy/ware/edit-commission`,
  merchant_config: `${VUE_APP_API}/qy/merchant/account/config`,
  clerk_list: `${VUE_APP_API}/qy/user/clerk/search`,
  ware_sku: `${VUE_APP_API}/qy/ware/sku/index`,
  edit_attr_stock: `${VUE_APP_API}/qy/ware/sku/update`,
};

@Component
export default class WareList extends Vue {
  loading: boolean = false;
  STATUS_LIST = STATUS_LIST;
  TYPE_LIST = WARE_TYPE_LIST;
  FILTER_DEFAULT_TYPE = FILTER_DEFAULT_TYPE;
  EDITABLE_WARE_FIELD = EditableWareFieldEnum;
  filter: Filter = getFilter();
  enable_to_preview: boolean = false;
  merchant_config: any = {};
  page: any = '';

  // dataIndex 作为 sort_by_[field] 参数复用，谨慎修改
  table_column_list = [
    {
      key: 'sort',
      dataIndex: 'sort',
      sorter: true,
      defaultSortOrder: getSortFilter().sort_by_sort,
      width: '100px',
      slots: { title: 'sort_title' },
      scopedSlots: { customRender: 'sort' },
    },
    {
      key: 'price',
      dataIndex: 'price',
      sorter: true,
      slots: { title: 'ware_title' },
      scopedSlots: { customRender: 'ware' },
    },
    {
      key: 'stock',
      dataIndex: 'stock',
      sorter: true,
      slots: { title: 'stock_title' },
      scopedSlots: { customRender: 'stock' },
    },
    {
      title: '总销量',
      key: 'sale_volume',
      dataIndex: 'sale_volume',
      sorter: true,
    },
    {
      key: 'bonus',
      dataIndex: 'bonus',
      sorter: true,
      slots: { title: 'bonus_title' },
      scopedSlots: { customRender: 'bonus' },
    },
    {
      title: '创建时间',
      key: 'create_time',
      dataIndex: 'create_time',
      sorter: true,
      width: '140px',
      scopedSlots: { customRender: 'create_time' },
    },
    {
      title: '操作',
      key: 'operation',
      dataIndex: 'operation',
      scopedSlots: { customRender: 'operation' },
    },
  ];

  table_data: Pagination<Ware> = getTableData();
  summary: { [prop: number]: number } = getSummary();

  selected_ware_data: GlobalCheckData = getGlobalCheckData();
  current_page_all_check = {
    checked: false,
    indeterminate: false,
  };
  package_type: number = 0;
  modelLayout: any = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };
  category_list: any = [];
  table_popup: TablePopup = getTablePopup();

  ware_preview_modal: WarePreviewModal = getWarePreviewModal();

  stock_modal: StockModal = getStockModal();

  bonus_modal: BonusModal = getBonusModal();

  get currentSelectedWareData(): CheckData {
    return this.selected_ware_data[this.table_data.current];
  }

  get globalCheckedWareCount(): number {
    return _.reduce(
      this.selected_ware_data,
      (count: number, data: CheckData) => {
        return count + data.checked_list.length;
      },
      0
    );
  }

  get isStockTabActive(): boolean {
    return this.filter.status === StatusEnum.stock;
  }

  filterSelectPopupContainer() {
    return this.$refs.filter;
  }

  paginationOption(data: Pagination<any>) {
    return {
      total: data.total,
      showTotal: (total: number) => `共${total}条，每页${data.size}条`,
      pageSize: data.size,
      current: data.current,
    };
  }

  resetFilter() {
    this.filter = getFilter(this.filter.status);
  }

  resetGlobalCheckData() {
    this.selected_ware_data = getGlobalCheckData(this.table_data.last);
  }

  handleTabClick(status: StatusEnum) {
    this.filter.status = status;
    this.resetFilter();
    this.query();
  }

  handleSearchClick() {
    this.query();
  }

  handleTableChange(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    const filter = this.filter as any;
    const sort_filter_key_list = Object.keys(getSortFilter());

    /* 判断排序是否没有变化，没有直接查询 page 变化后数据，有则重置 page 后查询 */

    // 查询排序数据
    const is_next_sort_exist = Object.keys(sorter).length > 0;
    const next_sort_key = is_next_sort_exist ? `sort_by_${sorter.field}` : '';
    const next_sort_value = is_next_sort_exist ? sorter.order : SortEnum.default;

    // 当前排序数据
    let current_sort_key = '';
    const is_current_sort_exist = sort_filter_key_list.some((key: string) => {
      if (filter[key]) {
        current_sort_key = key;
      }
      return filter[key];
    });
    const current_sort_value = is_current_sort_exist ? filter[current_sort_key] : SortEnum.default;

    // 排序没有变化
    if (current_sort_key === next_sort_key && current_sort_value === next_sort_value) {
      this.query(next_page, false); // 翻页不重置 globalCheckData
      return;
    }

    // 清空当前排序
    if (is_current_sort_exist) {
      (this.filter as any)[current_sort_key] = SortEnum.default;
    }

    // 设置新排序
    if (is_next_sort_exist) {
      (this.filter as any)[next_sort_key] = next_sort_value;
    }
    this.query();
  }

  handleWareSelect(selected_row_keys: any[]) {
    const is_all_checked = selected_row_keys.length === this.table_data.data.length;
    this.selected_ware_data[this.table_data.current] = getCheckData(
      selected_row_keys,
      is_all_checked,
      !(is_all_checked || selected_row_keys.length === 0)
    );
  }

  handleCheckAllInCurrentPage({ target }: { target: HTMLInputElement }) {
    const checked = target.checked;
    this.selected_ware_data[this.table_data.current] = checked
      ? getCheckData(
          this.table_data.data.map((ware: Ware) => ware.id),
          true
        )
      : getCheckData();
  }

  handleTablePopupTriggerClick(ware: Ware, field: EditableWareFieldEnum) {
    console.debug(ware);
    this.table_popup = getTablePopup(ware.id, ware[field], field);
  }

  isTablePopupShow(popup: TablePopup, record: Ware, field: EditableWareFieldEnum) {
    return popup.visible && popup.id === record.id && popup.field === field;
  }

  handleTablePopupCancel() {
    this.table_popup = getTablePopup();
  }

  async handleTablePopupCommit(id: number, field: EditableWareFieldEnum) {
    const send_data: any = { id };
    let api: string;
    const value: string | number = this.table_popup.value;
    switch (field) {
      case EditableWareFieldEnum.sort: {
        if (!/^[1-9]+\d*$/.test(value.toString())) {
          this.$message.error('排序需为整数值');
          return;
        }
        send_data.sort = value;
        api = API.update_sort;
        break;
      }
      default:
        this.$message.error('修改出错');
        return;
    }

    const _data = ((await this.$axios.post(api, send_data)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.$message.success('修改成功');
    this.query(this.table_data.current, false);
    this.table_popup = getTablePopup();
  }

  async handleWarePreviewClick(id: number) {
    this.ware_preview_modal = getWarePreviewModal(true, await fetchPosterQrcode(id));
  }
  async getCategoryList() {
    const res = await this.$axios.get(API.category_list);
    if (res.data.status === 200) {
      this.category_list = res.data.data;
      this.category_list.unshift({ id: 0, name: '全部' });
      console.log(res.data.data);
    }
  }
  async handleStockClick() {
    const id_list = _.reduce(
      this.selected_ware_data,
      (list: number[], data: CheckData) => {
        return [...list, ...data.checked_list];
      },
      []
    );
    const _data =
      (
        (await this.$axios.post(API.stock, {
          id_list,
        })) || {}
      ).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.$message.success('操作成功');
    this.query();
  }

  async handleOnlineClick() {
    const id_list = _.reduce(
      this.selected_ware_data,
      (list: number[], data: CheckData) => {
        return [...list, ...data.checked_list];
      },
      []
    );
    const _data =
      (
        (await this.$axios.post(API.online, {
          id_list,
        })) || {}
      ).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.$message.success('操作成功');
    this.query();
  }

  async query(page: number = 1, is_reset_global_check_data: boolean = true) {
    const filter = this.filter;
    let sort_data: any = {
      sort: filter.sort_by_sort,
      price: filter.sort_by_price,
      current_stock: filter.sort_by_stock,
      sales: filter.sort_by_sale_volume,
      profit: filter.sort_by_gross_profit,
      commission_rule: filter.sort_by_bonus,
      create_time: filter.sort_by_create_time,
    };
    const sort_data_map: any = {
      [SortEnum.default]: '',
      [SortEnum.asc]: 'asc',
      [SortEnum.desc]: 'desc',
    };
    _.each(sort_data, (value: SortEnum, key: string) => (sort_data[key] = sort_data_map[value]));
    clean(sort_data);
    if (Object.keys(sort_data).length === 0) {
      sort_data = null;
    }
    this.page = page;
    const saler_id_list: any = [];
    const send_data = {
      category_id_first: filter.category_id[0],
      category_id_second: filter.category_id[1],
      status: filter.status,
      page,
      name: filter.name,
      type: filter.type[0],
      type_secondary: filter.type[1],
      create_time: filter.create_time_range.map((time: Moment) => date(time)),
      price: filter.price_range,
      sales: filter.sale_volume_range,
      current_stock: filter.stock_range,
      sort_queue: sort_data ? JSON.stringify(sort_data) : '',
    };
    clean(send_data);
    this.loading = true;
    try {
      const _data = ((await this.$axios.get(API.query, { params: send_data })) || {}).data || {};
      if (_data.error) {
        this.$message.error(_data.message);
        throw new Error(_data);
      }
      const data = _data.data;
      this.summary = getSummary();
      data.summary.forEach((item: { mark_status: number; count: number }) => {
        this.summary[item.mark_status] = item.count;
      });
      this.table_data = getTableData(data);

      if (is_reset_global_check_data) {
        this.resetGlobalCheckData();
      }
    } catch (e) {
      console.error(e);
    }
    this.loading = false;
  }

  async editStock() {
    if (this.stock_modal.is_sku) {
      this.stock_modal.visible = false;
      return;
    }
    if (!this.stock_modal.merchantNumber) {
      this.$message.error('请输入商家剩余库存数');
      return;
    }
    if (!/(^[1-9]+\d*$)|(^0$)/.test(this.stock_modal.merchantNumber.toString())) {
      this.$message.error('库存数需为整数值');
      return;
    }
    const send_data: any = {
      ware_id: this.stock_modal.id,
      target_stock: this.stock_modal.merchantNumber,
    };
    const _data = ((await this.$axios.post(API.edit_stock, send_data)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.$message.success('修改成功');
    this.stock_modal.visible = false;
    this.query();
  }

  async getStockData(item: any) {
    if (item.is_enable_attribute > 0) {
      this.getSkuDetail(item);
    } else {
      const _data = ((await this.$axios.get(`${API.stock_data}?ware_id=${item.id}`)) || {}).data || {};
      if (_data.error) {
        this.$message.error(_data.message);
        return;
      }
      const data = _data.data;
      this.stock_modal = {
        id: item.id,
        visible: true,
        title: `剩余库存 ${item.stock_total}`,
        merchantName: this.merchant_config.name,
        merchantNumber: item.stock,
        salerList: data,
        is_sku: false,
        stock_table: [],
        attr_name: [],
      };
    }
  }

  async getSkuDetail(item: any) {
    const _data = ((await this.$axios.get(`${API.ware_sku}?ware_id=${item.id}`)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    const data = _data.data || {};
    const sku_list = data.sku_list;
    sku_list.forEach((item: any) => {
      item.detail = JSON.parse(item.detail_json);
    });
    const attr_name_arr = [
      sku_list[0].detail[0][0].text,
      sku_list[0].detail[1] ? sku_list[0].detail[1][0].text : '',
      sku_list[0].detail[2] ? sku_list[0].detail[2][0].text : '',
    ]; // detail的长度代表有几个属性名称
    this.stock_modal = {
      id: item.id,
      visible: true,
      title: `剩余库存 ${item.stock_total}`,
      merchantName: '',
      merchantNumber: '',
      salerList: [],
      is_sku: true,
      stock_table: sku_list,
      attr_name: attr_name_arr,
    };
  }

  async changeAttrStock(item: any) {
    const _data =
      (
        (await this.$axios.post(API.edit_attr_stock, {
          sku_id: item.id,
          stock_num: item.stock_num,
        })) || {}
      ).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.$message.success('修改成功');
    this.query(this.page);
  }

  async getMerchantConfig() {
    const _data = ((await this.$axios.get(API.merchant_config)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.merchant_config = _data.data;
  }

  showBonusModal(item: any) {
    this.bonus_modal = {
      id: item.id,
      visible: true,
      oneselfNumber: item.commission_one_self,
      firstSalerNumber: item.commission_one_two,
      secondSalerNumber: item.commission_two,
      price: item.price,
    };
  }

  async editBonus() {
    const bonus = this.bonus_modal;
    if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(bonus.oneselfNumber.toString())) {
      this.$message.error('奖金标准需为最多两位小数的非负数');
      return;
    }
    if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(bonus.firstSalerNumber.toString())) {
      this.$message.error('奖金标准需为最多两位小数的非负数');
      return;
    }
    if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(bonus.secondSalerNumber.toString())) {
      this.$message.error('奖金标准需为最多两位小数的非负数');
      return;
    }
    if (
      bonus.oneselfNumber >= bonus.price ||
      bonus.firstSalerNumber >= bonus.price ||
      bonus.secondSalerNumber >= bonus.price ||
      bonus.firstSalerNumber + bonus.secondSalerNumber >= bonus.price
    ) {
      const _this = this;
      this.$confirm({
        title: '单件商品奖励≥商品价格，是否继续提交？',
        onOk() {
          _this.editBonusDetail();
        },
        onCancel() {
          return;
        },
      });
    } else {
      this.editBonusDetail();
    }
  }

  async editBonusDetail() {
    const bonus = this.bonus_modal;
    const send_data: any = {
      ware_id: bonus.id,
      commission_one_self: bonus.oneselfNumber,
      commission_one_two: bonus.firstSalerNumber,
      commission_two: bonus.secondSalerNumber,
    };
    const _data = ((await this.$axios.post(API.edit_commission, send_data)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.$message.success('修改成功');
    bonus.visible = false;
    this.query();
  }

  setFilterFromUrlQuery() {
    const query_obj = this.$route.query;
    _.each(query_obj, (value: any, key: string) => {
      if (!value && this.filter.hasOwnProperty(key)) {
        return;
      }
      // 数组查询条件特殊处理
      if (key === 'saler' && typeof value === 'string') {
        value = [value];
      }
      (this.filter as any)[key] = value;
    });
  }

  categoryFormat(first_id?: number | undefined, second_id?: number): string {
    if (!arguments.length) {
      return '';
    }
    const category_item: any = this.category_list.filter((item: any) => item.id === first_id)[0];
    let category_name: string = '';
    category_name = !second_id ? category_item.name : `${category_item.name}/${category_item.sub_category.filter((item: any) => item.id === second_id)[0].name}`;
    return category_name;
  }

  async created() {
    this.package_type = (storage.getItem('profile') || {}).package_type || 1;
    this.loading = true;
    this.setFilterFromUrlQuery();
    await this.getMerchantConfig();
    await this.getCategoryList();
    await this.query();
    this.enable_to_preview = (await fetchWarePageData()).is_app_online;
    this.$nextTick(() => {
      _.each(document.querySelectorAll('.ant-table-column-sorters'), (item: HTMLElement) => {
        item.title = '';
      });
    });
    console.log(this.category_list);
  }
}
